module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"allowCookie":"To perform better and correctly please allow to accept cookies in your browser settings","noInternet":"Please check your internet connection"},"th":{"allowCookie":"โปรดอนุญาตให้ใช้คุกกี้เพื่อพัฒนาและปรับปรุง ให้ระบบทำงานได้ถูกต้องและดียิ่งขึ้น","noInternet":"โปรดเช็คการเชื่อมต่ออินเทอร์เน็ตของคุณ"}}')
  delete Component.options._Ctor
}
